import { render, staticRenderFns } from "./contentpaymentreport.vue?vue&type=template&id=679cff86"
import script from "./contentpaymentreport.vue?vue&type=script&lang=js"
export * from "./contentpaymentreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports